var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationTabs',{attrs:{"children-routes":_vm.childrenRoutes,"newNotifications":_vm.newNotifications.length}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }